/**
 * GateCampaignBadge Component
 *
 * Displays a stylized badge showing "Gate 2x" when the user:
 * - Is using Gate wallet
 * - Campaign is active
 * - Hasn't exceeded the bonus cap
 *
 * Uses Gate's official branding (blue/green gradient).
 */

import config from '@/config';
import { useGateCampaign } from '@/hooks/useGateCampaign';

// Gate brand colors
const GATE_GREEN = '#17E6A1';
const GATE_BLUE = '#2354E6';

export function GateCampaignBadge() {
  const { campaignData, isLoading } = useGateCampaign();

  // Feature flag check
  if (!config.ENABLE_GATE_WALLET_CAMPAIGN) {
    return null;
  }

  // Only show badge if user is using Gate wallet and hasn't reached the cap
  if (isLoading || !campaignData?.isActive || !campaignData?.isEligible || campaignData?.remainingBonus <= 0) {
    return null;
  }

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full"
      style={{
        background: 'rgba(240, 240, 240, 0.95)',
        border: `2px solid ${GATE_GREEN}`,
        boxShadow: `0 0 12px rgba(23, 230, 161, 0.4), 0 0 8px rgba(35, 84, 230, 0.3)`,
      }}
    >
      <img src="/gate-color-short.png" alt="Gate" className="h-3" />
      <span
        className="text-xs font-bold"
        style={{
          background: `linear-gradient(90deg, ${GATE_BLUE}, ${GATE_GREEN})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          fontFamily: 'Outfit, sans-serif',
        }}
      >
        2x
      </span>
    </div>
  );
}
